import React from "react"
import { Tooltip } from "antd"
import PropTypes from "prop-types"
import "./ActionItemDocs.scss"

const ActionItemDocs = ({ data }) => {
  if (!data || !data.docs || data.docs.length === 0) return null

  const docsArray = data.docs.map((doc) => {
    if (!doc) return null
    // docs is array of strings
    if (typeof doc === "string") return doc
    // docs is array of objects
    else if (doc.document_name) return doc.document_name
    // sometimes only the document ID is available
    else if (doc.document_id) return doc.document_id
    return null
  })

  const visibleDocs = docsArray.slice(0, 5)
  const hiddenDocs = docsArray.slice(5)
  const allDocsText = docsArray.join(", ")

  return (
    <span className="action-item-docs-wrapper">
      {visibleDocs.join(", ")}
      {hiddenDocs.length > 0 && (
        <Tooltip title={allDocsText}>
          <span className="docs-tooltip">{`, +${hiddenDocs.length}`}</span>
        </Tooltip>
      )}
    </span>
  )
}

ActionItemDocs.propTypes = {
  data: PropTypes.shape({
    docs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
    docs_count: PropTypes.number,
  }),
}

export default ActionItemDocs
